class TabSelector {
    constructor(element, parameters = {}) {
        this.tabWrapper = element;
        this.tabs = this.tabWrapper.querySelectorAll('.k-tab-selector');
        this.previousTab = null;

        let {
            selectedIndexValue = 0,
            optionActive = 'selectedIndexValue',
            // 
            borderColor = '#999999',
            background = '#FFFFFF',
            color = '#333333',
            activeBackground = '#1A92EA',
            activeBorder = '#1A92EA',
            activeColor = '#FFFFFF',
            // 
            callback  = null
        } = parameters;

        this.parameters = {
            selectedIndexValue,
            optionActive,
            // 
            borderColor,
            background,
            color,
            activeBackground,
            activeBorder,
            activeColor,
            // 
            callback
        };

        this._configureTabOptions();
    }


    _configureTabOptions() {
        for (let i = 0; i < this.tabs.length; i++) {
            const tab = this.tabs[i];
            this._removeActiveStyles(tab);
            tab.setAttribute('selectedIndexValue', i);

            tab.addEventListener('click', (e) => {
                this.setActiveTab({
                    tab: tab.getAttribute('selectedIndexValue'),
                    optionActive: 'selectedIndexValue'
                })
            })
        }   

        this.setActiveTab({
            tab: this.parameters.selectedIndexValue,
            optionActive: this.parameters.optionActive
        });
    }

    _setActiveStyles(tab) {
        if (tab) {
            tab.style.backgroundColor = this.parameters.activeBackground;
            tab.style.color = this.parameters.activeColor;
            tab.style.borderColor = this.parameters.activeBorder;
            tab.setAttribute('tabActive', true);
            tab.classList.add('active');

            if (this.parameters.callback) {
                let callbackData = {
                    selectedIndexValue: tab.getAttribute('selectedIndexValue'),
                    tabValue: tab.getAttribute('tabValue'),
                    tabElement: tab,
                    previousTab: null
                }
                if (this.previousTab !== null) {
                    callbackData.previousTab = this.previousTab;
                    callbackData.previousTab = {
                        selectedIndexValue: this.previousTab.getAttribute('selectedIndexValue'),
                        tabValue: this.previousTab.getAttribute('tabValue'),
                        tabElement: this.previousTab
                    }
                }
                this.parameters.callback(callbackData);
            }
        }
    }

    _removeActiveStyles(tab) {
        if (tab) {
            tab.style.borderColor = this.parameters.borderColor;
            tab.style.backgroundColor = this.parameters.background;
            tab.style.color = this.parameters.color;
            tab.setAttribute('tabActive', false);
            tab.classList.remove('active');
        }
    }

    // tab: index | value 
    // option: tab-index | tab-value
    setActiveTab(tabOption = { tab: 0, optionActive: 'selectedIndexValue' }) {
        for (let i = 0; i < this.tabs.length; i++) {
            const tab = this.tabs[i];
            if (tab.getAttribute('tabActive') == true) {
                this.previousTab = tab;
            }

            if (tabOption.optionActive == 'selectedIndexValue') {
                if (tab.getAttribute('selectedIndexValue') == tabOption.tab) {
                    this._setActiveStyles(tab);
                } else {
                    this._removeActiveStyles(tab);
                }
            } else if (tabOption.optionActive == 'tabValue') {
                if (tab.getAttribute('tabValue') == tabOption.tab) {
                    this._setActiveStyles(tab);
                } else {
                    this._removeActiveStyles(tab);
                }
            }   
        }
    }
}


let tabInstances = [];

const init = (tabWrappers, tabParameters) => {
    if (tabWrappers) {
        if (typeof tabWrappers.length == 'undefined') {
            const htmlElement = tabWrappers;
            const parameters = tabParameters;
            tabInstances = new TabSelector(htmlElement, parameters);
        } else {
            for (let i = 0; i < tabWrappers.length; i++) {
                const htmlElement = tabWrappers[i];
                const parameters = tabParameters;
                let modalInstance = new TabSelector(htmlElement, parameters);
                tabInstances.push(modalInstance);
            }
        }
    }

    return tabInstances;
}


export {
    init
};